<template>
  <div class="access-registration-home">
    <!--section class="hero-card">
      <div class="hero-badge">公开登记入口</div>
      <h1>出入登记</h1>
      <p>请选择需要填写的登记模块。当前先开放人员入场登记，其余模块将按同一交互方式逐步上线。</p>
    </section-->

    <section
      v-for="group in moduleGroups"
      :key="group.title"
      class="group-card"
    >
      <div class="group-header">
        <h2>{{ group.title }}</h2>
        <span>{{ group.desc }}</span>
      </div>

      <div class="module-grid">
        <button
          v-for="item in group.items"
          :key="item.moduleType"
          type="button"
          class="module-tile"
          @click="openModule(item)"
        >
          <div class="module-tile__title">
            <span>{{ item.title }}</span>
            <!--van-tag
              v-if="item.enabled"
              size="medium"
              type="success"
              round
            >
              已开放
            </van-tag>
            <van-tag
              v-else
              size="medium"
              plain
              round
            >
              开发中
            </van-tag-->
          </div>
          <div class="module-tile__desc">{{ item.desc || `${item.formTitle}，支持查看本机最近填写记录。` }}</div>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { getAccessRegistrationGroups } from '@/utils/accessRegistration';

export default {
  name: 'AccessRegistrationHome',
  data() {
    return {
      moduleGroups: getAccessRegistrationGroups()
    };
  },
  methods: {
    openModule(item) {
      if (!item.path) {
        return;
      }

      this.$router.push(item.path).catch(() => {});
    }
  }
};
</script>

<style scoped>
.access-registration-home {
  min-height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.hero-card,
.group-card {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}

.hero-card {
  padding: 22px 20px;
  color: #fff;
  background:
    radial-gradient(circle at top right, rgba(255, 255, 255, 0.18), transparent 34%),
    linear-gradient(135deg, #0f5fc3 0%, #3d9cf4 100%);
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.18);
}

.hero-card h1 {
  margin: 0 0 10px;
  font-size: 28px;
  line-height: 1.12;
}

.hero-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
}

.group-card {
  padding: 18px;
}

.group-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 16px;
}

.group-header h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-primary);
}

.group-header span {
  font-size: 12px;
  color: var(--text-muted);
  text-align: right;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.module-tile {
  border: none;
  width: 100%;
  padding: 18px 16px;
  border-radius: 20px;
  text-align: left;
  background: linear-gradient(180deg, #f8fbff 0%, #f0f6ff 100%);
  border: 1px solid #dce9fb;
  cursor: pointer;
}

.module-tile__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.module-tile__desc {
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.6;
}

@media (max-width: 767px) {
  .access-registration-home {
    padding: 14px;
  }

  .hero-card,
  .group-card,
  .module-tile {
    border-radius: 20px;
  }

  .module-grid {
    grid-template-columns: 1fr;
  }

  .group-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .group-header span {
    text-align: left;
  }
}
</style>
